import React, { useEffect, useState } from 'react';
import { GetCoockie } from "../GlobalScript";
import { useNavigate } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FooterDealer from '../FooterDealer.js';

export default function ComingSoon() {
    const navigate = useNavigate();

    useEffect(() => {
        let ck = GetCoockie();
        console.log(ck);
        if (!ck) {
            navigate('/login');
        }

    }, [GetCoockie()])

    return (
        <>
            <Container className="checkout-container main-container min-height-spacing-lg">

                <Card className="help-card">
                    <Row className="title-group title-group-active return-title-row faq-heading">
                        <Col sm={11} className="return-title-col">
                            <Card.Title className="vertical-line heading card-main-title active-heading faqs-title" role="heading">Coming Soon</Card.Title>
                        </Col>
                    </Row>       
                </Card>

            </Container>

            <FooterDealer />
        </>
    )
}